import {Validation, ValidatorObject} from '../types/Validations';

/**
 * @param {ValidatorObject[]} validatorsArray Validators that will be used to generated a validations list
 * @returns {Validation} Validation
 */
export const createValidatorObject = (
    validatorsArray?: ValidatorObject[]
): Validation => {
    const validationsObject: Validation = {
        status: 'validating',
        errors: 0,
        checks: {}
    };

    if (Array.isArray(validatorsArray)) {
        validatorsArray.forEach((validator) => {
            validationsObject.checks[validator.key] = false;
        });
    }

    return validationsObject;
};
